import { createMuiTheme } from "@material-ui/core/styles";

import palette from "./palette";
import { getDirection } from "../localization";

const direction = getDirection();

const theme = createMuiTheme({
  direction,
  palette: {
    type: "dark",
    ...palette,
  },
  typography: {
    fontFamily:
      direction === "rtl"
        ? '"IRANSans", Tahoma, Arial, sans-serif'
        : '-apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif',
    h1: {
      fontWeight: 800,
      letterSpacing: direction === "rtl" ? 0 : "-0.035em",
    },
    h2: {
      fontWeight: 800,
      letterSpacing: direction === "rtl" ? 0 : "-0.025em",
    },
    h3: {
      fontWeight: 800,
    },
    h4: {
      fontWeight: 750,
    },
    button: {
      fontWeight: 700,
      textTransform: "none",
    },
  },
  shape: {
    borderRadius: 16,
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        body: {
          backgroundColor: "#060D18",
        },
      },
    },
    MuiButton: {
      root: {
        textTransform: "none",
      },
    },
    MuiIconButton: {
      root: {
        transition:
          "background-color .2s ease, color .2s ease, border-color .2s ease, transform .2s ease",
      },
    },
    MuiChip: {
      root: {
        maxWidth: "100%",
      },
      label: {
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
  },
});

export default theme;
